export default __webpack_public_path__ + "static/map-a45d34a36174f49aa2cd85c70ef5af6e.jpg";